import { IPhongNamHocRequest } from "../../../models/request/danh-muc/IPhongNamHocRequest"
import { noitru_phong_namhoc } from "../../../models/response/category/noitru_phong_namhoc"

export enum ePhongNamHocActionTypesIds {
    LOAD_START = "PHONG_NAM_HOC_LOAD_START",
    LOAD_SUCCESS = "PHONG_NAM_HOC_LOAD_SUCCESS",
    LOAD_ERROR = "PHONG_NAM_HOC_LOAD_ERROR",

    SELECT_START = "PHONG_NAM_HOC_SELECT_START",
    SELECT_SUCCESS = "PHONG_NAM_HOC_SELECT_SUCCESS",
    SELECT_ERROR = "PHONG_NAM_HOC_SELECT_ERROR"
}

export interface IPhongNamHocLoadStart {
    type: ePhongNamHocActionTypesIds.LOAD_START,
}
export interface IPhongNamHocLoadSuccess {
    type: ePhongNamHocActionTypesIds.LOAD_SUCCESS,
    payload: noitru_phong_namhoc[]
}
export interface IPhongNamHocLoadErr {
    type: ePhongNamHocActionTypesIds.LOAD_ERROR,
    payload: string
}
export interface IPhongNamHocSelectStart {
    type: ePhongNamHocActionTypesIds.SELECT_START
}
export interface IPhongNamHocSelectSuccess {
    type: ePhongNamHocActionTypesIds.SELECT_SUCCESS,
    payload: noitru_phong_namhoc[]
}
export interface IPhongNamHocSelectErr {
    type: ePhongNamHocActionTypesIds.SELECT_ERROR,
    payload: string
}

export type IPhongNamHocActionTypes = IPhongNamHocLoadStart | IPhongNamHocLoadSuccess | IPhongNamHocLoadErr |
    IPhongNamHocSelectStart | IPhongNamHocSelectSuccess | IPhongNamHocSelectErr